export const cycleFormConfig = ({
	cycleOptions = [],
	selectedCycle = ""
} = {}) => [
	{
		fields: [
			{
				name: "cycle",
				label: "Ciclo:",
				type: "select",
				defaultValue: selectedCycle,
				placeholder: "Selecione",
				options: cycleOptions,
				disabled: cycleOptions.length === 0,
				columns: 12
			}
		]
	}
];